import { experimentStates, experimentFlagsHelper } from '@zola-helpers/client';

const { CONTROL } = experimentStates;

// Experiment Keys
export const VIRTUAL_EVENTS = 'virtual-events';
export const WEB_TO_REG = 'web-to-reg';

const FALLBACK_VARIATIONS = {
  [VIRTUAL_EVENTS]: experimentFlagsHelper.createExperimentFlags(CONTROL, CONTROL, CONTROL),
  [WEB_TO_REG]: experimentFlagsHelper.createExperimentFlags(CONTROL, CONTROL, CONTROL),
};

export default experimentFlagsHelper.makeExperimentFlags(FALLBACK_VARIATIONS);



// WEBPACK FOOTER //
// ./src/util/experimentFlags.js